import { render, staticRenderFns } from "./NotesText.vue?vue&type=template&id=372b0d34&"
import script from "./NotesText.vue?vue&type=script&lang=js&"
export * from "./NotesText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports